<template>
    <div class="container pt-4" style="max-width: 500px; padding-bottom: 500px;">
        <div class="card">
            <h4 class="card-header p-3 text-center">Sign In</h4>
            <div class="card-body">
                <div class="mb-4 text-center"><b>Don't have an account? <router-link to="/register">Register</router-link></b></div>
                <div class="modal-body container px-3">
                    <div class="mb-3">
                        <input v-model="email" type="text" class="form-control" id="exampleFormControlInput5"
                            placeholder="Email">
                    </div>
                    <div class="input-group mb-3">
                        <input v-if="!viewPassword" type="password" class="form-control" id="exampleFormControlInput6" placeholder="Password" v-model="password">
                        <input v-if="viewPassword" type="text" class="form-control" id="exampleFormControlInput6" placeholder="Password" v-model="password">
                        <span v-if="!viewPassword" @click="togglePassword()" class="input-group-text" id="basic-addon2" style="border: none; border-radius: 10px;"><i style="color: grey;" class="fa-solid fa-eye"></i></span>
                        <span v-if="viewPassword" @click="togglePassword()" class="input-group-text" id="basic-addon2" style="border: none; border-radius: 10px;"><i style="color: grey;" class="fa-solid fa-eye-slash"></i></span>
                    </div>
                </div>
                <div class="modal-footer justify-content-center mt-4">
                    <button @click="getCandidate()" type="button" class="btn btn-success">Log In</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import DataService from '../services/dataservice'

export default {
    name: 'login',
    emits: ['toggleLoader'],
    data() {
        return {
            email: '',
            password: '',
            viewPassword: false
        }
    },
    mounted(){
        this.initialize()
    },
    methods: {
        togglePassword(){
            this.viewPassword = this.viewPassword == false ? true : false
        },
        async getCandidate() {
            this.$emit('toggleLoader');

            if (!this.email) {
                alert ('Enter email');
                this.$emit('toggleLoader');
                return
            }

            var regex = /^[\w\-\.\+]+\@[a-zA-Z0-9\. \-]+\.[a-zA-z0-9]{2,4}$/;
            if (this.email.match(regex) == null){
                alert ('Enter a correct email');
                this.$emit('toggleLoader');
                return
            }

            if (!this.password) {
                alert('Enter password');
                this.$emit('toggleLoader');
                return
            }

            var details = {
                email: this.email.trim().toLowerCase(),
                password: this.password
            }
                
            const user = await DataService.login(details);

            if (user) {
                this.$store.commit('connect', {_id: user.details._id, staffType: user.details.staffType, token: user.token});

                if (user.details.staffType == 'Academic Teaching' || user.details.staffType == 'Research' || user.details.staffType == 'Library') {
                    this.$router.push({ path: '/sectiona' });
                } else {
                    this.$router.push({ path: '/section1' });
                }

                this.$emit('toggleLoader');
            } else {
                this.$emit('toggleLoader');
            }
            
        },
        initialize() {
            if (DataService.isLoggedIn()) {
                this.$router.push({ path: `/` });
            }
        }
    }
}
</script>
